import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ButtonType, WalletAddress } from '@tassat/text';
import React from 'react';

interface WalletNameCellRendererProps {
    value: string;
    isAdmin?: boolean;
}

const muiStyles = makeStyles({
    root: {
        height: '100%',
        whiteSpace: 'normal' as const,
        wordBreak: 'break-word' as const
    }
});

const WalletAddressCellRenderer = (props: WalletNameCellRendererProps) => {
    const {
        value,
        isAdmin
    } = props;

    const classes = muiStyles(props);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <WalletAddress
                buttonType={ButtonType.SMALL}
                isAdmin={isAdmin}
                walletAddress={value}
            />
        </Grid>
    );
};

export default WalletAddressCellRenderer;